// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__Myagd","wrap":"Layout_wrap__T6oAX","content":"Layout_content__2mFQL"};